interface SuperDuty {
  env: {
    API_URL: string;
    APP_ENV: string;
    SENTRY_DSN: string;
    APP_VERSION: string;
  };
}

declare global {
  interface Window {
    superDuty: SuperDuty;
  }
}

// Initialize superDuty on window
window.superDuty = {
  env: {
    API_URL: import.meta.env.VITE_API_URL,
    APP_ENV: import.meta.env.VITE_APP_ENV,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    APP_VERSION: import.meta.env.VITE_APP_VERSION,
  },
};
